import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CouponDownloadDialog } from "@/components/Coupons/CouponDownloadDialog";
import useRedirect from "@/hooks/useRedirect";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { BRAND_HOME_PAGE, REGISTRATION_PAGE } from "@/settings/constant";
import { useRouter } from "next/router";
import { useState } from "react";
import { postSubscribeBrand } from "src/api/brand";
import { useDialogStore } from "src/store/useDialogStore";
import { useCarousel } from "../hooks/useCarousel";
import { useAuthorCouponsQuery, useBrandPreviewQuery, useDownloadCouponMutation } from "../queries";
import BrandCard from "./BrandCard";
import BrandSamplePreviewDialog from "./BrandSamplePreviewDialog/BrandSamplePreviewDialog";
import HomeCarouselButton from "./HomeCarouselButton";
import { HomeSectionTitle } from "./HomeSectionLayout";
import ViewAllCard from "./ViewAllCard";
const REQUIRED_LOGIN_DIALOG_ID = "required-login-dialog";
const BrandSection = (param)=>{
    let { title , header , ctaButtonLink , ctaButtonName , titleImageUrl , brands , onCouponDownload , entityId , homeId  } = param;
    const { open , close  } = useDialogStore();
    const { emblaRef , canScrollPrev , canScrollNext , scrollPrev , scrollNext  } = useCarousel();
    const [couponDialogOpen, setCouponDialogOpen] = useState(false);
    const [sampleDialogOpen, setSampleDialogOpen] = useState(false);
    const [selectedAuthorId, setSelectedAuthorId] = useState(null);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const { redirectTo , redirectToLogin  } = useRedirect();
    const { isLoggedIn  } = useAuthStore();
    const { isMobile  } = useWindowDimensions();
    const router = useRouter();
    var _selectedBrand_authorId;
    // 선택된 저자의 쿠폰 조회 (샘플 다이얼로그에서 미리 prefetch)
    const couponAuthorId = (_selectedBrand_authorId = selectedBrand === null || selectedBrand === void 0 ? void 0 : selectedBrand.authorId) !== null && _selectedBrand_authorId !== void 0 ? _selectedBrand_authorId : selectedAuthorId;
    const { data: couponData , isLoading: isCouponLoading  } = useAuthorCouponsQuery({
        authorId: String(couponAuthorId),
        enabled: (couponDialogOpen || sampleDialogOpen && (selectedBrand === null || selectedBrand === void 0 ? void 0 : selectedBrand.useGetCouponBtn)) && couponAuthorId !== null && isLoggedIn
    });
    // 쿠폰 다운로드 mutation
    const downloadCouponMutation = useDownloadCouponMutation({
        authorId: String(couponAuthorId)
    });
    var _selectedBrand_brandPreviewId;
    // 브랜드 프리뷰 조회
    const { data: previewData , isLoading: isPreviewLoading  } = useBrandPreviewQuery({
        brandPreviewId: (_selectedBrand_brandPreviewId = selectedBrand === null || selectedBrand === void 0 ? void 0 : selectedBrand.brandPreviewId) !== null && _selectedBrand_brandPreviewId !== void 0 ? _selectedBrand_brandPreviewId : 0,
        enabled: sampleDialogOpen && selectedBrand !== null
    });
    const handleCouponClick = (brand)=>{
        if (!isLoggedIn) {
            openLoginDialog();
            return;
        }
        setSelectedBrand(brand);
        setSelectedAuthorId(brand.authorId);
        setCouponDialogOpen(true);
    };
    // 샘플 보기 클릭
    const handleSampleClick = (brand)=>{
        // MX-376: 브랜드 섹션 브랜드 아이템 클릭 트래킹
        mixpanelEvent("[Home] Brand Section Clicked", {
            "Entity Id": entityId,
            "Section Title": title,
            Type: "브랜드 아이템 클릭",
            "Author Name": brand.authorName
        });
        setSelectedBrand(brand);
        setSampleDialogOpen(true);
    };
    // 샘플 다이얼로그에서 쿠폰 받기 클릭 (샘플 다이얼로그 위에 쿠폰 다이얼로그 표시)
    const handleSampleDialogCouponClick = ()=>{
        if (!selectedBrand) return;
        handleCouponClick(selectedBrand);
    };
    // 전체 자료 보기 클릭
    const handleViewAllClick = ()=>{
        ;
    };
    // 쿠폰 받기 클릭 시 브랜드 구독 + 쿠폰 다운로드 API 호출
    const handleCouponDownload = async (couponId)=>{
        var _couponData_coupons;
        // MX-374: 쿠폰 받기 버튼 클릭 트래킹
        const coupon = couponData === null || couponData === void 0 ? void 0 : (_couponData_coupons = couponData.coupons) === null || _couponData_coupons === void 0 ? void 0 : _couponData_coupons.find((c)=>c.id === couponId);
        var _coupon_name;
        mixpanelEvent("Coupon Get Button Clicked", {
            "Coupon Id": couponId,
            "Coupon Name": (_coupon_name = coupon === null || coupon === void 0 ? void 0 : coupon.name) !== null && _coupon_name !== void 0 ? _coupon_name : "",
            "Home Id": homeId
        });
        // 브랜드 구독 (쿠폰 다운로드와 무관하게 즉시 호출)
        if (selectedBrand === null || selectedBrand === void 0 ? void 0 : selectedBrand.brandName) {
            postSubscribeBrand({
                name: selectedBrand.brandName,
                isSubscribed: true
            }).catch(()=>{});
        }
        try {
            await downloadCouponMutation.mutateAsync(couponId);
            onCouponDownload === null || onCouponDownload === void 0 ? void 0 : onCouponDownload(couponId, selectedAuthorId);
        } catch (error) {
            ;
        }
    };
    const openLoginDialog = ()=>{
        open({
            id: REQUIRED_LOGIN_DIALOG_ID,
            type: "confirm",
            props: {
                title: "로그인이 필요해요.",
                description: "로그인 또는 회원가입을 진행해주세요.",
                confirmText: "회원가입",
                cancelText: "로그인",
                onConfirm: ()=>{
                    redirectTo(REGISTRATION_PAGE);
                },
                onCancel: ()=>{
                    redirectToLogin();
                },
                contentProps: {
                    onInteractOutside: ()=>{
                        close("".concat(REQUIRED_LOGIN_DIALOG_ID));
                    }
                }
            }
        });
    };
    var _selectedBrand_authorName, _couponData_coupons;
    return /*#__PURE__*/ _jsxs("section", {
        className: "my-10 flex w-full flex-col gap-6 max-sm:my-6 max-sm:gap-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-end justify-between gap-2",
                children: [
                    /*#__PURE__*/ _jsx(HomeSectionTitle, {
                        title: title,
                        header: header,
                        isUseButton: Boolean(ctaButtonLink),
                        buttonText: ctaButtonName,
                        buttonUrl: ctaButtonLink,
                        titleImageUrl: titleImageUrl
                    }),
                    brands.length >= 5 && /*#__PURE__*/ _jsx(HomeCarouselButton, {
                        canScrollPrev: canScrollPrev,
                        canScrollNext: canScrollNext,
                        scrollPrev: scrollPrev,
                        scrollNext: scrollNext
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "relative",
                children: /*#__PURE__*/ _jsx("div", {
                    ref: emblaRef,
                    className: "overflow-hidden max-lg:px-8 max-sm:px-5",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex gap-5 max-sm:gap-3",
                        children: [
                            brands.map((brand, idx)=>/*#__PURE__*/ _jsx(BrandCard, {
                                    className: "w-[285px] min-w-[200px] shrink-0",
                                    ...brand,
                                    sampleButton: {
                                        show: isMobile ? Boolean(brand.brandName) : brand.useBrandSampleBtn,
                                        label: isMobile ? "브랜드 홈 가기" : brand.brandSampleBtnName || "자료 샘플보기",
                                        onClick: isMobile ? ()=>router.push(BRAND_HOME_PAGE(brand.brandName)) : ()=>handleSampleClick(brand)
                                    },
                                    onCouponClick: ()=>handleCouponClick(brand)
                                }, "".concat(brand.brandPreviewId, "-").concat(idx))),
                            (brands === null || brands === void 0 ? void 0 : brands.length) >= 5 && Boolean(ctaButtonLink) && /*#__PURE__*/ _jsx(ViewAllCard, {
                                href: ctaButtonLink
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(CouponDownloadDialog, {
                open: couponDialogOpen && !isCouponLoading,
                onOpenChange: setCouponDialogOpen,
                title: "".concat((_selectedBrand_authorName = selectedBrand === null || selectedBrand === void 0 ? void 0 : selectedBrand.authorName) !== null && _selectedBrand_authorName !== void 0 ? _selectedBrand_authorName : "", " 할인 쿠폰 받기"),
                coupons: (_couponData_coupons = couponData === null || couponData === void 0 ? void 0 : couponData.coupons) !== null && _couponData_coupons !== void 0 ? _couponData_coupons : [],
                onDownload: handleCouponDownload,
                loadingCouponId: downloadCouponMutation.isLoading ? downloadCouponMutation.variables : undefined
            }),
            /*#__PURE__*/ _jsx(BrandSamplePreviewDialog, {
                open: sampleDialogOpen,
                onOpenChange: setSampleDialogOpen,
                brand: selectedBrand,
                previewData: previewData,
                isLoading: isPreviewLoading,
                onCouponClick: handleSampleDialogCouponClick,
                homeId: homeId
            })
        ]
    });
};
export default BrandSection;
